import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { ICalendar } from '@models/calendar/ICalendar';

export class CalendarService {
    static async fetchCalendar(): Promise<AxiosResponse<ICalendar>> {
        return $api.get<ICalendar>(`/calendar`);
    }
}
